import { h } from 'preact';
import Article from './article';

export default function App() {
  return <Article />;
}
